<template>
	<div ref="chart" style="width: 100%; height: 100%"></div>
</template>

<script>
import { formatDate } from "@/plugins/date.js";
export default {
	props: {
		chartData: Object,
	},
	watch: {
		chartData: {
			handler() {
				this.$nextTick(() => {
                    this.initChart();
                })
			},
			immediate: true,
		},
	},
	methods: {
		initChart() {
            if(!this.chartData.hostname) return
			var myChart = this.$echarts.init(this.$refs.chart);
            const dates = [],
                cpus = [],
                mems = [];
            this.chartData.cpus.forEach(item => {
                dates.push(formatDate(new Date(item.time), "yyyy-MM-dd hh:mm:ss"))
                cpus.push([item.time, item.used.toFixed(2) * 1])
            })
            this.chartData.mems.forEach(item => {
                mems.push([item.time, item.used.toFixed(2) * 1])
            })
			const option = {
				tooltip: {
					//设置tip提示
					trigger: "axis",
				},
				legend: {
					//设置区分（哪条线属于什么）
					data: [this.$t('Chart.txt1'), this.$t('Chart.txt2')],
					x: "center",
					y: "bottom",
				},
				color: ["#FF4683", "#1E90FF"], //设置区分（每条线是什么颜色，和 legend 一一对应）
				xAxis: {
					//设置x轴
					type: "time",
					boundaryGap: false, //坐标轴两边不留白
					data: dates,
					name: "(T)", //X轴 name
					nameTextStyle: {
						//坐标轴名称的文字样式
						color: "#BCBCBC",
						fontSize: 12,
						padding: [0, 0, 0, 15],
					},
					axisLine: {
						//坐标轴轴线相关设置。
						lineStyle: {
							color: "#BCBCBC",
						},
					},
				},
				yAxis: {
					type: "value",
					name: this.$t('Chart.txt3'),
					nameTextStyle: {
						color: "#BCBCBC",
						fontSize: 12,
						padding: [0, 0, 10, 0],
					},
					// splitLine: {
					//   show: false
					// },
					axisLine: {
						lineStyle: {
							color: "#BCBCBC",
						},
					},
				},
				series: [
					{
						name: this.$t('Chart.txt1'),
						data: cpus,
						type: "line", // 类型为折线图
                        clip: true,
                        smooth: true,
						lineStyle: {
							// 线条样式 => 必须使用normal属性
							normal: {
								color: "#FF9DBD",
							},
						},
					},
					{
						name: this.$t('Chart.txt2'),
						data: mems,
                        clip: true,
                        smooth: true,
						type: "line",
						lineStyle: {
							normal: {
								color: "#1E90FF",
							},
						},
					},
				],
			};
			myChart.setOption(option);
			// this.timer = setInterval(function () {
			// 	data.push(randomData());
			// 	if (data.length == 100) {
			// 		data.shift();
			// 	}
			// 	myChart.setOption(option);
			// }, 5000);
		},
	},
};
</script>